import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { Container } from 'components/Grid';

import StoreLocationAddressCard from './AddressCard';

const StoreLocations = ({ stores }) => {
  const { sortedStores, orderedCountries } = useMemo(() => {
    const sorted = stores.reduce((acc, store) => {
      if (!acc[store.countryRegion]) {
        acc[store.countryRegion] = [];
      }
      acc[store.countryRegion].push(store);
      return acc;
    }, {});

    const ordered = Object.keys(sorted).sort((a, b) => {
      if (a === 'United States') return -1;
      if (b === 'United States') return 1;
      return a.localeCompare(b);
    });

    return { sortedStores: sorted, orderedCountries: ordered };
  }, [stores]);

  return (
    <Container>
      {orderedCountries.map(country => (
        <div key={country}>
          <p className="mb-4 mt-8 text-2xl font-bold md:mb-6 md:mt-16">{country}</p>
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {sortedStores[country]
              .sort((a, b) => a.zipPostalCode.localeCompare(b.zipPostalCode))
              .map(store => (
                <StoreLocationAddressCard key={store.handle} store={store} />
              ))}
          </div>
        </div>
      ))}
    </Container>
  );
};

StoreLocations.propTypes = {
  stores: PropTypes.arrayOf(
    PropTypes.shape({
      countryRegion: PropTypes.string.isRequired,
      zipPostalCode: PropTypes.string.isRequired,
      handle: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default StoreLocations;
